/* ============================================================
   LMM Ratgeber-Landing — Variante B: client-seitiger Filter + Themen-Chips
   + „Mehr anzeigen"-Toggle je Themenmodul (V3 2026-07-26).
   Progressive Enhancement: ohne JS bleiben ALLE Karten + Tag-Links nutzbar
   (CSS zeigt Extras, wenn .rg-js fehlt; „Mehr"-Buttons sind dann versteckt).
   Läuft nur, wo .lmm-rg-land existiert. Abschnitte mit [data-rg-hide-on-search]
   blendet das CSS über die Root-Klasse .is-searching aus.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('.lmm-rg-land');
  if (!root) return;
  root.classList.add('rg-js');

  var input   = root.querySelector('[data-rg-search]');
  var cards   = Array.prototype.slice.call(root.querySelectorAll('.rg-card'));
  var groups  = Array.prototype.slice.call(root.querySelectorAll('.rg-group'));
  // Nur die Toggle-Buttons der Übersicht — Links (a.rg-chip / Sidebar) navigieren normal.
  var chips   = Array.prototype.slice.call(root.querySelectorAll('button.rg-chip[data-topic]'));

  // aktive Themen (Chip an/aus). Start: alle an.
  var active = {};
  chips.forEach(function (c) { active[c.getAttribute('data-topic')] = true; });

  function norm(s) { return (s || '').toLowerCase().trim(); }

  function groupActive(g) {
    var t = g.getAttribute('data-topic');
    return active[t] !== false;
  }

  function apply() {
    var term = norm(input ? input.value : '');
    var searching = term.length > 0;
    root.classList.toggle('is-searching', searching);

    var totalVisible = 0;

    if (!searching) {
      // Default: Gruppe sichtbar wenn Chip an; Extra-Sichtbarkeit regeln CSS (.rg-open) + Filterzustand.
      cards.forEach(function (card) {
        card.style.display = '';
      });
      groups.forEach(function (g) {
        g.style.display = groupActive(g) ? '' : 'none';
        if (groupActive(g)) totalVisible++;
      });
    } else {
      // Suche: ALLE Karten (inkl. Extras) durchsuchen; Gruppe nur wenn Chip an.
      groups.forEach(function (g) {
        var on = groupActive(g);
        var hits = 0;
        var gcards = g.querySelectorAll('.rg-card');
        Array.prototype.forEach.call(gcards, function (card) {
          var match = on && (card.getAttribute('data-search') || '').indexOf(term) !== -1;
          card.style.display = match ? '' : 'none';
          if (match) hits++;
        });
        g.style.display = (on && hits > 0) ? '' : 'none';
        totalVisible += hits;
      });
    }
    root.classList.toggle('is-empty', totalVisible === 0);
  }

  function setChip(chip, on) {
    chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    active[chip.getAttribute('data-topic')] = on;
  }

  chips.forEach(function (chip) {
    if (!chip.hasAttribute('aria-pressed')) chip.setAttribute('aria-pressed', 'true');
    chip.addEventListener('click', function (e) {
      // Modifier/Mittelklick: normalen Anker-Sprung zulassen
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      var on = chip.getAttribute('aria-pressed') === 'true';
      setChip(chip, !on);
      apply();
      var sec = root.querySelector('.rg-group[data-topic="' + chip.getAttribute('data-topic') + '"]');
      if (!on && sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // „Mehr anzeigen" je Themenmodul: zeigt die versteckten Extra-Karten der Gruppe.
  Array.prototype.forEach.call(root.querySelectorAll('[data-rg-more]'), function (btn) {
    btn.addEventListener('click', function () {
      var g = btn.closest('.rg-group');
      if (!g) return;
      var open = g.classList.toggle('rg-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var lo = btn.querySelector('[data-rg-more-open]');
      var lc = btn.querySelector('[data-rg-more-close]');
      if (lo) lo.hidden = open;
      if (lc) lc.hidden = !open;
      if (!open) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if (input) {
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(apply, 90);
    });
    // Esc leert das Feld
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { input.value = ''; apply(); }
    });
  }

  apply();
})();
